// src/app/app.routes.ts
import { Routes } from '@angular/router';
import { PageNotFoundComponent } from './features/page-not-found/page-not-found.component';
import HomeComponent from './features/home/home.component';


// Define tu array de rutas directamente
export const routes: Routes = [ // Exporta el array directamente
  {
    path: '',
    component: HomeComponent,
  },
  {
    path: 'home',
    component: HomeComponent,
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];